module.exports = __webpack_public_path__ + "static/4_2_recommendation_IS-f7679a48f6812041f40c8691b425485d.svg";